
import React, { ReactNode } from 'react';
import { FormField } from './FormField';

interface HotelFormSectionProps {
  title?: string;
  children: ReactNode;
}

export const HotelFormSection: React.FC<HotelFormSectionProps> = ({ 
  title, 
  children 
}) => {
  return (
    <div className="space-y-4">
      {title && <h3 className="text-sm font-medium">{title}</h3>}
      {children}
    </div>
  );
};

export interface HotelFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  icon?: ReactNode;
  type?: string;
  isTextarea?: boolean;
}

export const HotelField: React.FC<HotelFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  icon,
  type = 'text',
  isTextarea = false
}) => {
  return (
    <FormField
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      icon={icon}
      type={type}
      isTextarea={isTextarea}
    />
  );
};
